import "./MainHeader.css";

const MainHeader = () => {
    return (
        <h1 className="col-sm-12 col-md-4 col-lg-4 col-xl-4 display-2 align-self-center my-2 roboto-bold-italic">
            Мягкая мебель <span className="no-wrap">в Самаре</span></h1>
      );
}

export default MainHeader;